import { watch } from "vue";
/**
 * Copies the activated tab's filters into the live query, so the pills show what the tab applies
 * and "Enregistrer" saves an edited list as it is on screen.
 *
 * CONSTRAINT: call it before `useTableQueryUrlSync`. The URL sync activates the `?view=` tab while it
 * is set up and then applies the URL filters on top; registered later, this watcher misses that
 * first activation and a deep link loads without the tab's filters.
 */
export function useActiveViewFilters(tableQuery, tableViews) {
    // CONSTRAINT: flush "sync" applies the filters inside setView(). As a pre-flush watcher it could
    // run after the consuming view's own fetch watcher, which would then fetch once with the previous
    // tab's filters.
    watch(() => tableQuery.state.activeViewId, (id) => {
        const filters = tableViews.views.value.find((v) => v.id === id)?.querySnapshot?.filters;
        if (filters && Object.keys(filters).length > 0) {
            tableQuery.state.filters = JSON.parse(JSON.stringify(filters));
        }
        else if (Object.keys(tableQuery.state.filters).length > 0) {
            tableQuery.clearAllFilters();
        }
    }, { flush: "sync" });
}
